import { yearsAvailableForAnalysis } from './staticText.config';

export const csvColumnHeaders = [
  'Data',
  'Category',
  'Year',
  'Area Count (Acres)',
];

export const squaredMetersToAcres = 0.0002471052; // Acres = square meters * this number

export const computeHistogramReferences = [
  {
    id: 'Cumulative Plowprint',
    subCategories: [['N/A', 500]],
    years: yearsAvailableForAnalysis,
    squareMetersPerPixel: 900,
    url: 'https://maps.wwfus.org/server/rest/services/Plowprint/pp_analysis/ImageServer/computeHistograms',
    mosaicRule: null,
  },
  {
    id: 'Intact Habitat',
    subCategories: [
      ['Grassland', 10],
      ['Forest', 20],
      ['Shrubland', 30],
      ['Wetland', 40],
      ['Other', 50],
    ],
    years: yearsAvailableForAnalysis,
    squareMetersPerPixel: 900,
    url: 'https://maps.wwfus.org/server/rest/services/Plowprint/int_habitat_analysis/ImageServer/computeHistograms',
    mosaicRule: null,
  },
  {
    id: 'Plowprint Annual Expansion',
    subCategories: [
      ['Corn', 10],
      ['Wheat', 20],
      ['Soy', 30],
      ['Canola', 40],
      ['Other Grains', 60],
      ['Other Crops', 70],
    ],
    years: yearsAvailableForAnalysis,
    squareMetersPerPixel: 900,
    url: 'https://maps.wwfus.org/server/rest/services/Plowprint/ppannexp_analysis/ImageServer/computeHistograms',
    mosaicRule: null,
  },
  {
    id: 'Intact Extent',
    subCategories: [['N/A', 500]],
    years: yearsAvailableForAnalysis,
    squareMetersPerPixel: 900,
    url: 'https://maps.wwfus.org/server/rest/services/Plowprint/int_analysis/ImageServer/computeHistograms',
    mosaicRule: null,
  },
  {
    id: 'Intact Ownership',
    subCategories: [
      ['State Land', 1],
      ['Federal Land', 2],
      ['Private/Other', 3],
      ['Tribal', 4],
    ],
    squareMetersPerPixel: 900,
    years: yearsAvailableForAnalysis,
    url: 'https://maps.wwfus.org/server/rest/services/Plowprint/int_own_analysis/ImageServer/computeHistograms',
    mosaicRule: null,
  },
  {
    id: 'Plowprint Ownership',
    subCategories: [
      ['State Land', 1],
      ['Federal Land', 2],
      ['Private/Other', 3],
      ['Tribal', 4],
    ],
    years: yearsAvailableForAnalysis,
    squareMetersPerPixel: 900,
    url: 'https://maps.wwfus.org/server/rest/services/Plowprint/pp_own_analysis/ImageServer/computeHistograms',
    mosaicRule: null,
  },
  {
    id: 'Plowprint Composition',
    subCategories: [
      ['Perennial', 10],
      ['Forest', 20],
      ['Barren/Developed', 30],
      ['Crop/Fallow', 40],
    ],
    years: yearsAvailableForAnalysis,
    squareMetersPerPixel: 900,
    url: 'https://maps.wwfus.org/server/rest/services/Plowprint/pp_comp_analysis/ImageServer/computeHistograms',
    mosaicRule: null,
  },
  {
    id: 'Plowprint Expansion 2012 - 2020',
    subCategories: [
      ['Corn', 10],
      ['Wheat', 20],
      ['Soy', 30],
      ['Canola', 40],
      ['Other Grains', 60],
      ['Other Crops', 70],
    ],
    years: ['N/A'],
    squareMetersPerPixel: 900,
    url: 'https://maps.wwfus.org/server/rest/services/Plowprint/ppexp/ImageServer/computeHistograms',
    mosaicRule: null,
  },
  {
    id: 'Plowprint Soil Quality',
    subCategories: [
      ['Low', 1],
      ['Moderate', 2],
      ['High', 3],
      ['Very High', 4],
    ],
    years: ['N/A'],
    squareMetersPerPixel: 900,
    url: 'https://maps.wwfus.org/server/rest/services/Plowprint/soil/ImageServer/computeHistograms',
    // eslint-disable-next-line quotes
    mosaicRule: `Name = 'PP20_conrisk'`,
  },
  {
    id: 'Intact Soil Quality',
    subCategories: [
      ['Low', 1],
      ['Moderate', 2],
      ['High', 3],
      ['Very High', 4],
    ],
    years: ['N/A'],
    squareMetersPerPixel: 900,
    url: 'https://maps.wwfus.org/server/rest/services/Plowprint/soil/ImageServer/computeHistograms',
    // eslint-disable-next-line quotes
    mosaicRule: `Name = 'INT20_conrisk'`,
  },
  {
    id: 'Open Water',
    subCategories: [['N/A', 1]],
    years: ['N/A'],
    squareMetersPerPixel: 900,
    url: 'https://maps.wwfus.org/server/rest/services/Plowprint/waterdev/ImageServer/computeHistograms',
    // eslint-disable-next-line quotes
    mosaicRule: `Name = 'h2o_1_gp_2019'`, // ! Update
  },
  {
    id: 'Developed',
    subCategories: [['N/A', 1]],
    years: ['N/A'],
    squareMetersPerPixel: 900,
    url: 'https://maps.wwfus.org/server/rest/services/Plowprint/waterdev/ImageServer/computeHistograms',
    // eslint-disable-next-line quotes
    mosaicRule: `Name = 'dev_1_gp'`,
  },
];
